import React from 'react';
import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';

import ClientInput from '../molecules/ClientInput';

const MapOnDemandClientTemplate = (props) => {
  const {
    input,
    button,
    label,
  } = props;

  return (
    <Container>
      <ClientInput input={input} button={button} label={label} />
    </Container>
  );
};

export default MapOnDemandClientTemplate;

MapOnDemandClientTemplate.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    placeHolder: PropTypes.string.isRequired,
  }).isRequired,
  button: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  }).isRequired,
  label: PropTypes.shape({
    value: PropTypes.string,
  }),
  header: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }).isRequired,
};

MapOnDemandClientTemplate.defaultProps = {
  label: {
    value: '',
  },
};
